import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
export const CardHeaderTextContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const CardFooterContainer = styled.div `
  box-sizing: border-box;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${themeGet('spacing.xl')} ${themeGet('spacing.2xl')};
`;
export const CardContentContainer = styled.div `
  padding: ${({ $noPadding }) => ($noPadding ? 0 : `0 ${themeGet('spacing.2xl')} ${themeGet('spacing.2xl')}`)};
  height: 100%;
  background-color: ${themeGet('colors.background.50')};
`;
const boxShadow = (token) => {
    if (!token) {
        return undefined;
    }
    return css `
    box-shadow: ${themeGet(`dropShadow.${token}`)};
  `;
};
const cardBorder = (border = true) => {
    if (!border) {
        return undefined;
    }
    return css `
    border: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
  `;
};
export const CardHeaderContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${themeGet('spacing.2xl')};
  background-color: ${themeGet('colors.background.50')};
`;
export const CardHeaderContent = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${themeGet('spacing.md')};
  align-items: center;
`;
const smallSizeStyles = css `
  ${CardFooterContainer} {
    padding: ${themeGet('spacing.xl')} ${themeGet('spacing.xl')};
  }

  ${CardHeaderContainer} {
    padding: ${themeGet('spacing.xl')};
  }

  ${CardContentContainer} {
    padding: 0 ${themeGet('spacing.xl')} ${themeGet('spacing.xl')};
  }
`;
export const CardContainer = styled.div `
  display: flex;
  flex-direction: row;
  background-color: ${themeGet('colors.gray.0')};
  border-radius: ${themeGet('borderRadius.lg')};
  overflow: hidden;
  color: ${themeGet('color.200')};

  ${(props) => boxShadow(props.$dropShadow)};
  ${(props) => cardBorder(props.$border)};

  ${({ $size = 'default' }) => ($size === 'small' ? smallSizeStyles : null)};
`;
export const CardFooterActionsContainer = styled.div `
  display: flex;
  gap: ${themeGet('spacing.xl')};
  margin-left: auto;
`;
export const CardMedia = styled.div `
  flex: 0 0 ${(props) => props.$fraction * 100}%;
  background-color: ${themeGet('colors.primary.800')};
`;
export const CardBody = styled.div `
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  position: relative;
  min-width: 0;
`;
